/**
 * DOMPurify configuration for rich text content
 *
 * Allows standard HTML elements used in rich text while blocking
 * scripts, event handlers, and other XSS vectors.
 */
export const DOMPURIFY_CONFIG = {
  // Return string instead of TrustedHTML
  RETURN_TRUSTED_TYPE: false as const,
  // Allowed HTML tags for rich text
  ALLOWED_TAGS: [
    // Text formatting
    "p",
    "br",
    "strong",
    "b",
    "em",
    "i",
    "u",
    "s",
    "strike",
    "del",
    "sub",
    "sup",
    "code",
    "pre",
    // Headings
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    // Lists
    "ul",
    "ol",
    "li",
    // Links and media
    "a",
    "img",
    "figure",
    "figcaption",
    "iframe",
    // Block elements
    "blockquote",
    "div",
    "span",
    // Social embeds (custom wrappers)
    "button",
    // SVG (platform icons in consent overlays)
    "svg",
    "path",
    "rect",
    "line",
    "circle",
  ],
  // Allowed attributes
  ALLOWED_ATTR: [
    // Global
    "class",
    "id",
    "style",
    // Links
    "href",
    "target",
    "rel",
    // Images
    "src",
    "alt",
    "width",
    "height",
    "loading",
    // Iframes (for YouTube, Spotify, etc.)
    "frameborder",
    "allow",
    "allowfullscreen",
    "title",
    "scrolling",
    // TikTok embed blockquote
    "cite",
    // Data attributes for consent handling
    "data-platform",
    "data-embed-url",
    "data-embed-content",
    "data-consent-action",
    "data-consent-platform",
    "data-instgrm-captioned",
    "data-instgrm-permalink",
    "data-video-id",
    // Button
    "type",
    // SVG attributes (platform icons in consent overlays)
    "viewBox",
    "fill",
    "stroke",
    "stroke-width",
    "stroke-linecap",
    "stroke-linejoin",
    "d",
    "x",
    "y",
    "rx",
    "ry",
    "x1",
    "y1",
    "x2",
    "y2",
    "cx",
    "cy",
    "r",
  ],
  // Allow data: URIs for images only (some CMS may use base64 images)
  ALLOW_DATA_ATTR: true,
  // Force all links to have rel="noopener noreferrer" when target="_blank"
  ADD_ATTR: ["target"],
};
